<template>
  <v-container>
    <div class="container my-5">
      <v-img src="/img/icon/commentary.png" width="64" cover style="margin: auto;" />
      <div class="page-title text-center my-2">
        Event / <span class="page-title-japanese ml-3">unity1week</span>
      </div>
      <div class="page-abstract text-center my-4">
        1週間で作成されたゲームを1週間で全て遊ぶハードなイベント！<br>
        そのハードさから、他の実況者は真似出来ない...？！
      </div>
    </div>
    <h2 class="u1w-section-title">開催予定のイベント</h2>
    <div class="u1w-section-contents mt-4 mx-3">
      <v-card class="mx-auto" max-width="344"  @click="ToDetailPage">
        <v-img src="/img/unity1week-official.png" width="256" cover class="mx-auto"/>
        <v-divider></v-divider>
        <v-card-title>
          お題『つたえる』
        </v-card-title>
        <v-card-text>
          投稿数：??? 作品（現在、投稿期間中！）<br>
          放送予定日：3/27 (月) ～ 4/9 (日)
        </v-card-text>
      </v-card>
    </div>
    <h2 class="u1w-section-title">開催中のイベント</h2>
    <div class="mt-4 mb-5 mx-3" >
      開催中のイベントはありません
    </div>
    <h2 class="u1w-section-title">過去のイベント</h2>
    <div class="u1w-section-contents mt-4 mx-3">
      サイト引っ越しによる更新中です…
    </div>
  </v-container>
</template>
  
<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  methods: {
    ToDetailPage(){
      this.$router.push('/unity1week/detail')
    }
  }
}
</script>
  
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.page-title {
    color: #807866;
    font-size: 24px;
}

.page-title-japanese {
    color: #1b1e21;
    font-size: 60px;
}

.u1w-section-contents img {
    height: auto;
    width: auto;
    max-width: 100%;
    max-height: 100%;
    margin: auto;
}

.u1w-section-title {
    border-bottom: solid 3px #fd7e14;
}

/* 拾い物 */
.stretched-link::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    pointer-events: auto;
    content: "";
    background-color: rgba(0, 0, 0, 0)
}
</style>